import { Hero } from './hero';
import { Pricing } from './pricing';
import { Faq } from './faq';
import { Footer } from './footer';
import { Services } from './services';
import { Maps } from './maps';
import { useEffect, useRef } from 'react';
import CTA from './call-to-action';
import MediaQuery from '../helpers/media-query';
import { useLocation } from 'react-router-dom';
import FerriesMap from './ferries-map';
import Testimonials from './testimonials';
import { ContactForm } from './booking/contact-form';

export default function Home({ t }) {
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        const targetElementId = hash.slice(1); // Remove the '#' symbol from the hash

        if (targetElementId) {
            const targetElement = document.getElementById(targetElementId);

            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);
    const activeSuccessModal = useRef();
    const activeErrorModal = useRef();
    const { forEmail } = MediaQuery();
    return (
        <>
            {/* <!-- ======= Hero Section ======= --> */}
            <Hero t={t} />

            {/* <!-- End Hero Section --> */}

            <main id="main">
                {/* <!-- ======= Contact Section ======= --> */}
                <section id="book" className="contact pt-0">
                    <div className="container" data-aos="fade-up">
                        <div className="section-header">
                            <h2>{t('contact.title')}</h2>
                            <p>{t('contact.description')}</p>
                        </div>

                        <div className="row gx-lg-0 gy-4 flex-column-reverse flex-lg-row">
                            <div className="col-lg-5 col-xl-4">
                                <div className="info-container d-flex flex-column align-items-center justify-content-center">
                                    <div className="info-item d-flex">
                                        <i className="bi bi-geo-alt flex-shrink-0"></i>
                                        <div>
                                            <h4>{t('contact.address')}:</h4>
                                            <p>Via dei materassai 1/b, Livorno 57121, Italia</p>
                                        </div>
                                    </div>
                                    {/* <!-- End Info Item --> */}

                                    <div className="info-item d-flex">
                                        <i className="bi bi-envelope flex-shrink-0"></i>
                                        <div>
                                            <h4>Email:</h4>
                                            {forEmail ? (
                                                <p>
                                                    info@<br></br>
                                                    <span>parkingtransferlivorno.com</span>
                                                </p>
                                            ) : (
                                                <p>info@parkingtransferlivorno.com</p>
                                            )}
                                        </div>
                                    </div>
                                    {/* <!-- End Info Item --> */}

                                    <div className="info-item d-flex">
                                        <i className="bi bi-phone flex-shrink-0"></i>
                                        <div>
                                            <h4>{t('contact.phone')}:</h4>
                                            <p>+39 375 696 6969</p>
                                        </div>
                                    </div>
                                    {/* <!-- End Info Item --> */}

                                    <div className="info-item d-flex">
                                        <i className="bi bi-clock flex-shrink-0"></i>
                                        <div>
                                            <h4>{t('contact.hours')}:</h4>
                                            <p>7:00 - 22:00</p>
                                        </div>
                                    </div>
                                    {/* <!-- End Info Item --> */}
                                </div>
                            </div>

                            <ContactForm
                                activeSuccessModal={activeSuccessModal}
                                activeErrorModal={activeErrorModal}
                                t={t}
                            />
                            {/* <!-- End Contact Form --> */}
                        </div>
                    </div>
                </section>
                {/* <!-- End Contact Section --> */}

                <FerriesMap t={t} />

                <Pricing t={t} />

                <Services t={t} />

                <Faq t={t} />

                <Maps t={t} />
                <CTA t={t} />
            </main>

            <Testimonials t={t} />
            {/* <Gallery t={t} /> */}
            {/* <!-- ======= Footer ======= --> */}
            <Footer t={t} />
            {/* // <!-- Button trigger modal --> */}
            <button
                style={{ display: 'none' }}
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#successModal"
                ref={activeSuccessModal}
            >
                Launch success modal
            </button>
            <button
                style={{ display: 'none' }}
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#errorModal"
                ref={activeErrorModal}
            >
                Launch error modal
            </button>
            {/* // <!-- Modal --> */}
            <div
                className="modal fade"
                id="successModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalAfterContact"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content border-success border-2">
                        <div className="modal-header bg-success bg-opacity-75 justify-content-between">
                            <h5 className="modal-title" id="modalAfterContact">
                                {t('messageResponse.positive.title')}
                            </h5>

                            <span
                                aria-hidden="true"
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fi fi-br-cross"></i>
                            </span>
                        </div>
                        <div className="modal-body">
                            <p className="mb-0">
                                {t('messageResponse.positive.firstSentence')}
                                <br></br> {t('messageResponse.positive.secondSentence')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="modal fade"
                id="errorModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalAfterContact"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content border-danger border-2">
                        <div className="modal-header bg-danger bg-opacity-75 justify-content-between">
                            <h5 className="modal-title" id="modalAfterContact">
                                {t('messageResponse.negative.title')}
                            </h5>

                            <span
                                aria-hidden="true"
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fi fi-br-cross"></i>
                            </span>
                        </div>
                        <div className="modal-body">
                            <p className="mb-0">
                                {t('messageResponse.negative.firstSentence')} <br></br>{' '}
                                {t('messageResponse.negative.secondSentence')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
